<template>
  <div class="d-inline-block avatar-wrapper">
    <slot></slot>
    <div v-if="loading" class="avatar-background"><b-spinner></b-spinner></div>
    <div v-else-if="avatar" :style="`background-image: url(${avatar})`" class="avatar-background"></div>
    <img v-else src="@/assets/paw_print.png" class="avatar-image" alt="" />
  </div>
</template>

<script>
import { getImage } from '@/utils';

export default {
  name: 'AvatarImage',
  props: {
    image: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    avatar() {
      if (this.image) {
        return getImage(this.image.original);
      } else {
        return null;
      }
    },
  },
  methods: {
    getImage,
  },
};
</script>

<style lang="scss" scoped>
@import '~@docupet/component-library/src/assets/styles/_variables';
.avatar-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid $dp-gray-9;
}
.avatar-background {
  width: 80px;
  height: 80px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
  border: 1px solid $dp-gray-9;
}
.spinner-border {
  position: absolute;
  left: -7px;
  top: -21px;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>
